import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native';
import React, { useEffect, useState } from 'react';
import Box from '../../components/box/Box';
import DropDownPicker from '../picker/DropDownPicker.web';
import FilePicker from '../../components/filePicker/filepicker.web';
import Colors from '../../constants/Colors';
import { useSelector } from 'react-redux';
import Feather from "@expo/vector-icons/Feather";
import WizardFooter from './WizardFooter';
import TextInputComponent from '../textinput/TextInputComponent';

import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { MaterialIcons } from '@expo/vector-icons';
import ImagePreviewGrid from './ImagePreviewGrid';

const IssueFormStep = ({ slectedItems, onSubmit, onBack }) => {

  const { roomTypes, categoryTypes } = useSelector(
    (state) => state.maintenance
  );

  const [state, setState] = useState({
    title: '',
    date_opened: new Date(),
    room_type_id: '',
    category_id: '',
    description: '',
    issue_images: [],
  });

  const [errors, setErrors] = useState({});
  const [roomTypesArray, setRoomTypesArray] = useState([]);
  const [categoryTypesArray, setCategoryTypesArray] = useState([]);

  // Map dropdown values
  useEffect(() => {
    if (roomTypes?.data?.length) {
      const temp = roomTypes.data.map((element) => ({
        label: element?.name,
        value: element?.open_flow_maintenance_issue_room_type_id
      }));
      setRoomTypesArray(temp);
    }

    if (categoryTypes?.data?.length) {
      const temp = categoryTypes.data.map((element) => ({
        label: element?.name,
        value: element?.open_flow_maintenance_issue_category_id
      }));
      setCategoryTypesArray(temp);
    }
  }, [roomTypes, categoryTypes]);

  useEffect(() => {
    if (slectedItems?.open_flow_maintenance_issue_id) {
      setState({ ...state, ...slectedItems });
    }
  }, [slectedItems]);

  const handleChange = (label, value) => {
    setState({ ...state, [label]: value });
    setErrors({ ...errors, [label]: '' });
  };

  const handleFileUpload = (data) => {
    const value = [
      ...state.issue_images,
      ...data.map((image) => image.openbrixName)
    ];
    setState({ ...state, issue_images: value });
  };

  // ✅ VALIDATION
  const validate = () => {
    let newErrors = {};

    if (!state.title?.trim()) {
      newErrors.title = "Issue title is required";
    }

    if (!state.date_opened) {
      newErrors.date_opened = "Date is required";
    }

    if (!state.room_type_id) {
      newErrors.room_type_id = "Please select room type";
    }

    if (!state.category_id) {
      newErrors.category_id = "Please select category type";
    }

    if (!state.description?.trim()) {
      newErrors.description = "Description is required";
    }

    if (state.description.length > 400) {
      newErrors.description = "Maximum 400 characters allowed";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      onSubmit(state);
    }
  };

  return (
    <Box style={styles.container}>

      {/* TITLE + DATE */}
      <View style={styles.row}>
        <View style={styles.halfWidth}>
          <TextInputComponent
            title="Issue Title"
            value={state.title}
            onChangeText={(e) => handleChange('title', e)}
            height={45}
            error={errors.title}
          />
        </View>

        <View style={styles.halfWidth}>
          <Text style={styles.label}>Date Opened</Text>

          <DatePicker
            onChange={(date) => handleChange('date_opened', date)}
            value={state.date_opened}
            minDate={new Date()} // ✅ only today + future
            format="dd/MM/y"
            disabled={true}
            clearIcon={null}
            calendarIcon={<Feather name="calendar" size={18} color="#666" />}
            className="custom-date-picker"
          />

          {errors.date_opened && (
            <Text style={styles.error}>{errors.date_opened}</Text>
          )}
        </View>
      </View>

      {/* ROOM + CATEGORY */}
      <View style={styles.row}>
        <View style={styles.halfWidth}>
          <DropDownPicker
            items={roomTypesArray}
            title="Select Room Type"
            defaultValue={state.room_type_id}
            onChangeItem={(e) => handleChange('room_type_id', e.value)}
          />
          {errors.room_type_id && (
            <Text style={styles.error}>{errors.room_type_id}</Text>
          )}
        </View>

        <View style={styles.halfWidth}>
          <DropDownPicker
            items={categoryTypesArray}
            title="Select Category Type"
            defaultValue={state.category_id}
            onChangeItem={(e) => handleChange("category_id", e.value)}
          />
          {errors.category_id && (
            <Text style={styles.error}>{errors.category_id}</Text>
          )}
        </View>
      </View>

      {/* DESCRIPTION */}
      <View style={{ marginTop: 20 }}>
        <TextInputComponent
          title="Description"
          multiline
          height={120}
          value={state.description}
          onChangeText={(e) => handleChange('description', e)}
          error={errors.description}
        />
        <Text style={styles.charCount}>
          {state.description.length}/400
        </Text>
      </View>

      {/* IMAGES */}
      <View style={{ marginTop: 25 }}>
        <Text style={styles.attachTitle}>Attach Images</Text>

        <FilePicker
          style={{ width: '100%' }}
          onDataSuccess={(data) => handleFileUpload(data)}
        />
      </View>
      <ImagePreviewGrid
        images={state.issue_images}
        onDelete={(index) => {
          const updated = state.issue_images.filter((_, i) => i !== index);
          setState({ ...state, issue_images: updated });
        }}
      />

      <WizardFooter
        leftLabel="Back"
        rightLabel="Submit"
        onLeftPress={onBack}
        onRightPress={handleSubmit}
        showLeft={slectedItems?.open_flow_maintenance_issue_id?false:true}
      />

    </Box>
  );
};

export default IssueFormStep;

const styles = StyleSheet.create({
  fileContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 10,
    width: '100%',          // ✅ responsive
    alignSelf: 'center',

    // Shadow (mobile)
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
    elevation: 3,

    // Web shadow (Expo web)
    boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
  },

  iconBox: {
    width: 36,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    backgroundColor: '#f0f2f5',
    marginRight: 12,
  },

  fileText: {
    flex: 1,
    fontSize: 14,
    color: '#333',
    fontWeight: '500',
  },

  deleteBtn: {
    marginLeft: 8,
    padding: 6,
    borderRadius: 6,
    backgroundColor: '#fff1f0',
  },
  container: {
    borderRadius: 20,
    backgroundColor: '#fff',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  halfWidth: {
    width: '48%',
  },
  label: {
    marginBottom: 13,
    fontWeight: '500'
  },
  error: {
    color: 'red',
    fontSize: 12,
    marginTop: 4
  },
  charCount: {
    textAlign: 'right',
    color: 'gray',
    marginTop: 5,
    fontSize: 12,
  },
  attachTitle: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 10,
  },
});
